import { render } from "./AgentWhatsAppView.vue?vue&type=template&id=8d53dd48&scoped=true"
import script from "./AgentWhatsAppView.vue?vue&type=script&lang=js"
export * from "./AgentWhatsAppView.vue?vue&type=script&lang=js"

import "./AgentWhatsAppView.vue?vue&type=style&index=0&id=8d53dd48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d53dd48"]])

export default __exports__